<template>
    <BaseCard theme="assessment" padding="lg" as="article" class="text-ink">
        <div class="details font-semibold uppercase tracking-wider mb-1">{{ t("components.assessment.newSection") }}</div>
        <h2 class="title leading-snug">{{ section.title }}</h2>
        <p v-if="section.instructions" class="mt-3 body leading-relaxed">{{ section.instructions }}</p>
        <p v-if="section.description" class="mt-2 body-small leading-relaxed">{{ section.description }}</p>
        <div class="mt-5 details">{{ t("components.assessment.questionsInSection", { count: questionCount }, questionCount) }}</div>
    </BaseCard>
</template>

<script setup lang="ts">
import type { SectionSummary } from "~vue/api/generated/reflections";
import BaseCard from "~vue/components/BaseCard.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

interface Props {
    section: SectionSummary;
    questionCount: number;
}

defineProps<Props>();
</script>
